import {
  Default_getInstanceqol46f1ssq2p as Default_getInstance,
  Jsonsmkyu9xjl7fv as Json,
  Json1n3ogdvkni9sh as Json_0,
  JsonBuildere7k0u736arkf as JsonBuilder,
} from './kotlinx-serialization-kotlinx-serialization-json.mjs';
import {
  VOID3gxj6tk5isa35 as VOID,
  Unit_instance3vdlo4e4f5ggx as Unit_instance,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from './kotlin-kotlin-stdlib.mjs';
import { String25daxfxml2302 as String_0 } from './kotlinx-rpc-krpc-krpc-serialization-krpc-serialization-core.mjs';
import { plus1c7xncg0dvi6w as plus } from './kotlinx-serialization-kotlinx-serialization-core.mjs';
//region block: imports
//endregion
//region block: pre-declaration
class KrpcJsonSerialFormat {
  g92(from, builderConsumer) {
    var tmp = from == null ? Default_getInstance() : from;
    return Json(tmp, KrpcJsonSerialFormat$withBuilder$lambda(builderConsumer));
  }
  q8l(from, builderConsumer) {
    return this.g92((from == null ? true : from instanceof Json_0) ? from : THROW_CCE(), builderConsumer);
  }
  h92(_this__u8e3s4, serializersModule) {
    _this__u8e3s4.x2e_1 = plus(_this__u8e3s4.x2e_1, serializersModule);
  }
  p8l(_this__u8e3s4, serializersModule) {
    return this.h92(_this__u8e3s4 instanceof JsonBuilder ? _this__u8e3s4 : THROW_CCE(), serializersModule);
  }
}
//endregion
function json(_this__u8e3s4, from, builderConsumer) {
  from = from === VOID ? Default_getInstance() : from;
  var tmp;
  if (builderConsumer === VOID) {
    tmp = json$lambda;
  } else {
    tmp = builderConsumer;
  }
  builderConsumer = tmp;
  _this__u8e3s4.v8o(new String_0(KrpcJsonSerialFormat_instance, from, builderConsumer));
}
function KrpcJsonSerialFormat$withBuilder$lambda($builderConsumer) {
  return ($this$Json) => {
    $builderConsumer($this$Json);
    return Unit_instance;
  };
}
var KrpcJsonSerialFormat_instance;
function KrpcJsonSerialFormat_getInstance() {
  return KrpcJsonSerialFormat_instance;
}
function json$lambda(_this__u8e3s4) {
  return Unit_instance;
}
//region block: post-declaration
initMetadataForObject(KrpcJsonSerialFormat, 'KrpcJsonSerialFormat');
//endregion
//region block: init
KrpcJsonSerialFormat_instance = new KrpcJsonSerialFormat();
//endregion
//region block: exports
export {
  json as json3e0hzni0i002,
};
//endregion
